import { lazy } from 'react'

import i18n from 'translations'

export const bloxOfferings = [
  {
    name: i18n.t('blox-selection:offerChoose'),
    component: lazy(() => import('../../modules/public/Offerings')),
    path: '/public/:institutionId/offerings',
    guards: [],
  },
]
